/* tslint:disable:max-line-length */

import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { APIConfigService } from '../apiconfig.service';

import * as __utils from '../yasag-utils';

import * as __model from '../model';

export interface ListParams {
  /** A search term. */
  search?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
}

export interface CreateParams {
  data: __model.TipusServei;
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
}

export interface ExportTipusServeiParams {
  /** A search term. */
  search?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
}

export interface ImportServiceTypeParams {
  data: __model.ImportCSV;
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
}

export interface ReadParams {
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
  /** A unique integer value identifying this tipus servei. */
  id: number;
}

export interface UpdateParams {
  data: __model.TipusServei;
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
  /** A unique integer value identifying this tipus servei. */
  id: number;
}

export interface PartialUpdateParams {
  data: __model.TipusServei;
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
  /** A unique integer value identifying this tipus servei. */
  id: number;
}

export interface DeleteParams {
  /** A unique integer value identifying this tipus servei. */
  id: number;
}

@Injectable()
export class TipusServeiService {
  constructor(
    private http: HttpClient,
    private apiConfigService: APIConfigService) {}


  /** Gets a list of attribute categories */
  list(params: ListParams, multipart = false): Observable<__model.TipusServeiList> {
    const queryParamBase = {
      search: params.search,
      limit: params.limit,
      offset: params.offset,
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    return this.http.get<__model.TipusServeiList>(this.apiConfigService.options.apiUrl + `/tipus_servei/`, {params: queryParams});
  }

  /** Creates an attribute category */
  create(params: CreateParams, multipart = false): Observable<__model.TipusServei> {
    const bodyParams = params.data;
    const bodyParamsWithoutUndefined = __utils.getBodyParamsWithoutUndefined(multipart, bodyParams);

    const queryParamBase = {
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    return this.http.post<__model.TipusServei>(this.apiConfigService.options.apiUrl + `/tipus_servei/`, bodyParamsWithoutUndefined, {params: queryParams});
  }

  /** Endpoint to export tipus servei to CSV */
  exportTipusServei(params: ExportTipusServeiParams, multipart = false): Observable<string> {
    const queryParamBase = {
      search: params.search,
      limit: params.limit,
      offset: params.offset,
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    return this.http.get(this.apiConfigService.options.apiUrl + `/tipus_servei/export_tipus_servei/`, {params: queryParams, responseType: 'text'});
  }

  /** Endpoint to import service types from CSV */
  importServiceType(params: ImportServiceTypeParams, multipart = false): Observable<string> {
    const bodyParams = params.data;
    const bodyParamsWithoutUndefined = __utils.getBodyParamsWithoutUndefined(multipart, bodyParams);

    const queryParamBase = {
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    return this.http.post(this.apiConfigService.options.apiUrl + `/tipus_servei/import_service_type/`, bodyParamsWithoutUndefined, {params: queryParams, responseType: 'text'});
  }

  /** Gets an attribute category with its attributes */
  read(params: ReadParams, multipart = false): Observable<__model.TipusServei> {
    const queryParamBase = {
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    const pathParams = {
      id: params.id,
    };
    return this.http.get<__model.TipusServei>(this.apiConfigService.options.apiUrl + `/tipus_servei/${pathParams.id}/`, {params: queryParams});
  }

  /** Updates an attribute category */
  update(params: UpdateParams, multipart = false): Observable<__model.TipusServei> {
    const bodyParams = params.data;
    const bodyParamsWithoutUndefined = __utils.getBodyParamsWithoutUndefined(multipart, bodyParams);

    const queryParamBase = {
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    const pathParams = {
      id: params.id,
    };
    return this.http.put<__model.TipusServei>(this.apiConfigService.options.apiUrl + `/tipus_servei/${pathParams.id}/`, bodyParamsWithoutUndefined, {params: queryParams});
  }

  /** Updates an attribute category partially */
  partialUpdate(params: PartialUpdateParams, multipart = false): Observable<__model.TipusServei> {
    const bodyParams = params.data;
    const bodyParamsWithoutUndefined = __utils.getBodyParamsWithoutUndefined(multipart, bodyParams);

    const queryParamBase = {
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    const pathParams = {
      id: params.id,
    };
    return this.http.patch<__model.TipusServei>(this.apiConfigService.options.apiUrl + `/tipus_servei/${pathParams.id}/`, bodyParamsWithoutUndefined, {params: queryParams});
  }

  /** Deletes an attribute category from the DB */
  delete(params: DeleteParams, multipart = false): Observable<string> {
    const pathParams = {
      id: params.id,
    };
    return this.http.delete(this.apiConfigService.options.apiUrl + `/tipus_servei/${pathParams.id}/`, {responseType: 'text'});
  }
}
